import { Box, Spinner } from '@ouster/webviz-react-components';

import isEmpty from 'lodash/isEmpty';
import { RiFileList3Line } from 'react-icons/ri';

import DashboardCard from './DashboardCard';
import InfoItem from './InfoItem';
import { EulaInformation, InfoItemType } from './types';
import { formatDate } from './utils';

interface UserLookUpEulaProps {
  isUserFound: boolean;
  eulaInfo: EulaInformation | null;
  isLoadingUserLookup: boolean;
}

export default function UserLookUpEula({
  isUserFound,
  eulaInfo,
  isLoadingUserLookup,
}: UserLookUpEulaProps) {
  const cardProps = {
    icon: <RiFileList3Line size={20} />,
    title: 'EULA Information',
  };

  if (isLoadingUserLookup) {
    return (
      <DashboardCard {...cardProps}>
        <Box display="flex" alignItems="center" justifyContent="center" my={8} data-testid="user-lookup-eula-loading">
          <Spinner />
        </Box>
      </DashboardCard>
    );
  }

  if (!isUserFound) return null;

  if (!eulaInfo || isEmpty(eulaInfo)) {
    return (
      <DashboardCard {...cardProps}>
        <Box my={8} data-testid="user-lookup-eula-empty">We don&apos;t have any EULA information for this user.</Box>
      </DashboardCard>
    );
  }

  const userInfoItems: InfoItemType[] = [
    {
      label: 'Status',
      value: eulaInfo.status ? 'Accepted' : 'TBD',
      color: eulaInfo.status ? 'success' : 'error',
    },
    { label: 'Version', value: eulaInfo.version ?? '' },
    {
      label: 'Accepted At',
      value: eulaInfo.accepted_at
        ? formatDate(String(eulaInfo.accepted_at))
        : '',
    },
    { label: 'Country', value: eulaInfo.country ?? 'N/A' },
    { label: 'State', value: eulaInfo.state ?? 'N/A' },
    {
      label: 'Email Opt Out',
      value: eulaInfo.email_opt_out ? 'Yes' : 'No',
      color: eulaInfo.email_opt_out ? 'error' : 'info',
    },
  ];

  return (
    <DashboardCard {...cardProps} data-testid="user-lookup-eula-card">
      <Box
        display="grid"
        gridTemplateColumns="repeat(3, 1fr)"
        columnGap={4}
        rowGap={6}
        data-testid="user-lookup-eula-grid"
      >
        {userInfoItems.map((item) => (
          <InfoItem
            key={item.label}
            label={item.label}
            value={item.value}
            color={item.color}
            data-testid={`user-lookup-eula-item-${item.label
              .toLowerCase()
              .replace(/\s/g, '-')}`}
          />
        ))}
      </Box>
    </DashboardCard>
  );
}
